import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { CommissionSource } from "../enums";

interface Props {
  source: CommissionSource;
  style?: React.CSSProperties;
}

export const CommissionSourceTag = ({ source, style }: Props) => {
  const { t } = useTranslation();

  let color: string;

  switch (source) {
    case CommissionSource.COMMISSION_BASE_AMOUNT:
      color = "blue";
      break;
    case CommissionSource.COMMISSION_AMOUNT:
      color = "cyan";
      break;
  }

  return (
    <Tag style={style} color={color}>
      {t("commissions.settings.enums.commissionSource." + source)}
    </Tag>
  );
};
